<template>
  <div v-if="unpaid && unpaid !== 'paid'" :class="{'state-error': unpaid === 'locked'}" class="state-warning unpaid">
    <p>{{ 'billings:invoices.unpaid' | trans }}</p>
    <p v-if="unpaid === 'locked'">{{ 'billings:invoices.unpaid_locked' | trans }}</p>
    <p v-else>{{ 'billings:invoices.unpaid_remain' | trans({days: unpaid}) }}</p>
    <router-link v-if="link" :to="{name: target_path}" class="btn">
      {{ 'billings:invoices.view' | trans }}
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'Unpaid',
    data () {return {
      target_path: 'billings',
    }},
    computed: {
      link () {
        var path = this.$route.name;
        if (!path) {
          return true;
        }
        return path.split('.')[0] !== this.target_path;
      },
    },
    asyncComputed: {
      unpaid () {
        return this.async('billing_plan').then(() => this.$store.getters.unpaid);
      },
    }
  }
</script>

<style lang="scss" scoped>
  div.unpaid {
    font-weight: 700;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/sections/billings/components/Unpaid.vue